import { render } from "./BadgeField.vue?vue&type=template&id=4ec56434"
import script from "./BadgeField.vue?vue&type=script&lang=js"
export * from "./BadgeField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BadgeField.vue"]])

export default __exports__